import { isEqualStrings, isNotEqualStrings } from "@chef/utils/equal";
import type { IDeviationProduct } from "../../features";

export const getUpdatedDeviationProducts = (
  product: IDeviationProduct,
  basket: IDeviationProduct[],
) => {
  const productShouldBeRemovedFromBasket = product.quantity === 0;

  if (productShouldBeRemovedFromBasket) {
    return basket.filter((basketProduct) =>
      isNotEqualStrings(basketProduct.variationId, product.variationId),
    );
  }

  const productExistsInBasket = basket?.some((basketProduct) =>
    isEqualStrings(basketProduct.variationId, product.variationId),
  );

  if (!productExistsInBasket) {
    return [...basket, product];
  }

  return basket.map((basketProduct) => {
    if (isNotEqualStrings(basketProduct.variationId, product.variationId)) {
      return basketProduct;
    }

    return product;
  });
};
